module.exports = __webpack_public_path__ + "post-listing-block-3-image@2x-2eVrpTQ.jpg";